import { MenuStyle } from './menu.style';

export function Menu({ children, width }: { children: React.ReactNode; width?: string }) {
  return <MenuStyle.Container style={{ width }}>{children}</MenuStyle.Container>;
}
